export const enumPermisosDavivienda = Object.freeze({
  Recaudo_empresarial_PDP: 4001,
  Recaudo_empresarial_contingencia_PDP: 4002,
  Recaudo_empresarial_transacciones_PDP: 4003,
});
